import { DiscussionAlertsPreferencesPanel, ShellPreferencesPanel } from '@jarvis/platform-ui';
import { useShellPreferencesStore } from '../../shell/useShellPreferencesStore';

export function SettingsGeneralPage() {
  return (
    <div className="user-settings-sections">
      <ShellPreferencesPanel useShellPreferencesStore={useShellPreferencesStore} />
      <DiscussionAlertsPreferencesPanel />
    </div>
  );
}
